import { Component } from '@angular/core';

@Component({
  selector: 'pt-no-available-stats',
  template: `
    <div class='alert alert-warning alert-stats' style="padding: 2px 10px;">
      <span class="d-inline-flex">{{'MESSAGE.NO_AVAILABLE_STATS' | translate}}</span>
      <ng-content></ng-content>
    </div>
  `,
  styles: [`
    .alert-stats {
      padding: 2px 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  `]
})
export class NoAvailableStatsComponent {

}
